import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
const PURCHASES = [{
  name: 'Martín',
  city: 'Buenos Aires'
}, {
  name: 'Lucas',
  city: 'Córdoba'
}, {
  name: 'Javier',
  city: 'Rosario'
}, {
  name: 'Diego',
  city: 'Mendoza'
}, {
  name: 'Pablo',
  city: 'La Plata'
}, {
  name: 'Nicolás',
  city: 'Mar del Plata'
}, {
  name: 'Fernando',
  city: 'Tucumán'
}, {
  name: 'Matías',
  city: 'Neuquén'
}, {
  name: 'Alejandro',
  city: 'Santa Fe'
}, {
  name: 'Sebastián',
  city: 'Salta'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const showPopup = () => {
      const randomPerson = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPerson);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      const nextDelay = Math.random() * (15000 - 8000) + 8000 + 4000;
      timeoutId = setTimeout(showPopup, nextDelay);
    };
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(timeoutId);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-40" style={{
    animation: 'slideInLeft 0.3s ease-out'
  }} data-id="element-16">
      <style data-id="element-17">{`
        @keyframes slideInLeft {
          from {
            transform: translateX(-100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
      <div className="bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-center gap-3 max-w-xs md:max-w-sm" data-id="element-18">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-19">
          <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-20" />
        </div>
        <div data-id="element-21">
          <p className="text-sm font-bold text-gray-900" data-id="element-22">
            {currentPurchase.name} de {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-23">
            acaba de comprar MegaPack Salir Sin Luchar
          </p>
          <p className="text-xs text-green-600 font-medium mt-0.5" data-id="element-24">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}